export default function useMediaQuery() {

	const screenWidth = window.screen.width;

	const isMobile: boolean = screenWidth <= 600;

	return { isMobile };
}